// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".f5e2b99189706ff0166afee6408ee7e1f06c3323.chunk.bundle.js";
};